<template>
  <div class="content-wrapper">
    <section class="content">
      <div class="row" style="text-align: center;" >
        <div class="col-sm-12 col-lg-8 col-md-8 col-md-offset-2">
          <div class="panel panel-default">
            <div class="panel-body">
              <h1>Redeem Ticket</h1>
              <p>"Festival Musik & Seni Outdoor Berkelas Dunia Pertama di Indonesia"</p>
              <form @submit.prevent="onSubmit" style="margin-top: 35px;">
                <div class="row">
                  <div class="col-md-6">
                    <div :class="formValidation.voucherCode === '' ? 'form-group input-group-lg':  'form-group input-group-lg has-error'">
                      <label style="color: #333333 !important;">Voucher Code</label>
                      <input
                        v-model="voucherCode"
                        ref="voucherCodeRef"
                        type="text"
                        class="form-control"
                        :readonly="isReadonlyVoucher"
                        @keypress="(event)=>handleKeyPress(event, 'wristband_code')"
                        placeholder="Voucher code">
                        <span v-if="formValidation.voucherCode !== ''" class="help-block">{{ formValidation.voucherCode }} </span>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div :class="formValidation.wrisbandCode === '' ? 'form-group input-group-lg' : 'form-group input-group-lg has-error'">
                      <label style="color: #333333 !important;">Wrisband Code</label>
                      <input
                        v-model="wrisbandCode"
                        @keypress="(event)=>handleKeyPress(event, 'submit')"
                        ref="wrisbandCodeRef"
                        type="text"
                        class="form-control"
                        placeholder="Wrisband code">
                        <span v-if="formValidation.wrisbandCode !== ''" class="help-block">{{ formValidation.wrisbandCode }} </span>
                    </div>
                  </div>
                </div>
                <div class="row" style="margin-top: 15px;">
                  <button v-if="isLoading" type="button" class="btn btn-primary btn-flat" disabled> <ProgressLoader size="15"/> Loading...</button>
                  <button v-if="!isLoading" type="submit" class="btn btn-primary btn-flat">Linked</button>
                </div>
              </form>

              <Transition name="fade">
                <div style="margin-top: 15px;" v-if="message.shown">
                  <div :class="`alert alert-dismissible ${message.type}`" role="alert">
                    <button type="button" @click="onResetMessage()" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    {{ message.text }}
                    <ol v-if="message.item" style="text-align: start;">
                      <li v-for="(list, index) in message.item" :key="index">
                       <b>{{ index.toUpperCase() }}</b> : {{ list }}
                      </li>
                  </ol>
                  </div>
                </div>
              </Transition>

            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { Circle } from 'vue-loading-spinner';

export default {
  components: {
    ProgressLoader: Circle,
  },
  data() {
    return {
      isLoading: false,
      isReadonlyVoucher: false,
      voucherCode: '',
      wrisbandCode: '',
      message: {
        shown: false,
        item: [],
        text: '',
        type: '', // alert-danger alert-success
      },
      formValidation: {
        voucherCode: '',
        wrisbandCode: '',
      },
    };
  },
  mounted() {
    this.focusInput();
  },
  methods: {
    async handleKeyPress(event, nextFieldId) {
      try {
        if (event.key === 'Enter') {
          if (nextFieldId === 'voucher_code') {
              this.onFocusVoucherInput();
          }

          if (nextFieldId === 'wristband_code') {
            this.onResetMessage();
            const formData = new FormData();
            formData.append('ticket_item_code', this.voucherCode);
            const res = await this.axios.post('/ticketItems/check/ticket', formData);
            if (res.data.status_payment !== 'paid') {
              this.message.item = res.data;
              throw new Error(`Payment status is ${res.data.status_payment}`);
            }
            if (res.data.status_ticket === 'redeem' || res.data.status_ticket === 'checkin') {
              this.message.item = res.data;
              throw new Error(`Ticket status is ${res.data.status_ticket}`);
            }

            this.message.shown = true;
            this.message.item = res.data;
            this.message.type = 'alert-success';
            this.isReadonlyVoucher = res.data.status_payment === 'paid';
            this.onFocusWrisbandInput();
          }

          if (nextFieldId === 'submit') {
              this.onSubmit();
          }
        }
      } catch (errors) {
        console.error('[ERR ONSUBMIT]', errors.response);
        console.error('[ERR ONSUBMIT]', errors.message);
        if (nextFieldId === 'wristband_code') {
          this.voucherCode = '';
        }
        this.message.shown = true;
        this.message.item = [];
        this.message.text = errors.message ? errors.message : errors.response.data.errors;
        this.message.type = 'alert-danger';
      }
    },
    validateForm() {
      if (!this.voucherCode) {
        this.formValidation.voucherCode = 'Please field with valid voucher code';
        return false;
      }

      // if (!this.wrisbandCode) {
      //   this.formValidation.wrisbandCode = 'Please field with valid wristband code';
      //   return false;
      // }
      return true;
    },
    async onSubmit() {
      this.onResetMessage();
      const validation = this.validateForm();
      if (!validation) return;

      if (this.voucherCode !== '' && this.wrisbandCode !== '') {
        try {
            this.isLoading = true;
            const formData = new FormData();
            formData.append('ticket_item_code', this.voucherCode);
            formData.append('wristband_code', this.wrisbandCode);

            const res = await this.axios.post('/ticketItems/redeem', formData);

            this.message.shown = true;
            this.message.item = [];
            this.message.text = res.data.message;
            this.message.type = 'alert-success';
        } catch (errors) {
          console.error('[ERR ONSUBMIT]', errors.response);
          this.message.shown = true;
          this.message.text = errors.response.data.errors;
          this.message.item = [];
          this.message.type = 'alert-danger';
        } finally {
          this.isLoading = false;
          this.onClearForm();
          this.onFocusVoucherInput();
          // setTimeout(() => this.onResetMessage(), 5000);
        }
      }
    },
    onResetMessage() {
      this.message.shown = false;
      this.message.text = '';
      this.message.type = '';
      this.message.item = [];
    },
    onClearForm() {
      this.voucherCode = '';
      this.wrisbandCode = '';
      this.formValidation.voucherCode = '';
      this.formValidation.wrisbandCode = '';
      this.isReadonlyVoucher = false;
      this.isLoading = false;
    },
    onFocusWrisbandInput() {
      this.$refs.wrisbandCodeRef.focus();
    },
    onFocusVoucherInput() {
      this.$refs.voucherCodeRef.focus();
    },
  },
};
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.form-control {
  border-top: 0px !important;
  border-left: 0px !important;
  border-right: 0px !important;
  border-radius: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/modules/ticketing/redeem.vue